import { Mic2 } from "lucide-react";
import { T } from "@/i18n";

export const Speakers = ({ lang }) => {
  return (
    <section id="speakers" data-testid="speakers-section" className="relative py-20 sm:py-28">
      <div className="gc-waves" />
      <div className="relative z-10 mx-auto max-w-6xl px-4 sm:px-6">
        <p data-testid="speakers-sub" className={`text-center text-sm uppercase tracking-[0.3em] text-[#FFE500] ${lang === "kn" ? "font-kn normal-case tracking-normal" : ""}`}>
          {T.speakers.sub[lang]}
        </p>
        <h2 data-testid="speakers-heading" className={`mt-3 text-center font-display text-4xl font-bold uppercase text-white sm:text-5xl ${lang === "kn" ? "font-kn normal-case" : ""}`}>
          {T.speakers.heading[lang]}
        </h2>
        <div className="mx-auto mt-14 flex max-w-2xl flex-col items-center gap-12 sm:grid sm:grid-cols-[1.35fr_1fr] sm:items-end sm:gap-10">
          {/* Main speaker — prominent placement */}
          <div data-testid="speaker-main" className="w-full max-w-[300px] sm:max-w-none">
            <div className="relative">
              <div className="absolute -inset-2.5 rounded-3xl bg-[#FFE500]/10 blur-xl" />
              <img
                data-testid="speaker-photo-main"
                src="/assets/speaker-main.jpg"
                alt="Rev. Dr. Babu K Mathew — Main Speaker"
                className="relative aspect-[3/4] w-full rounded-2xl border border-[#FFE500]/30 object-cover object-top shadow-2xl"
              />
              <span data-testid="speaker-main-badge" className="absolute left-1/2 top-3 flex -translate-x-1/2 items-center gap-1.5 whitespace-nowrap rounded-full bg-[#FFE500] px-3.5 py-1.5 text-[11px] font-bold uppercase tracking-wide text-[#0B1233]">
                <Mic2 className="h-3 w-3" /> {T.speakers.mainBadge[lang]}
              </span>
            </div>
            <h3 data-testid="speaker-main-name" className="mt-6 text-center font-display text-lg font-bold uppercase tracking-wide text-white sm:text-2xl">
              Rev. Dr. Babu K Mathew
            </h3>
            <p className={`mt-1 text-center text-xs text-[#FFE500]/80 sm:text-sm ${lang === "kn" ? "font-kn" : ""}`}>{T.speakers.mainBadge[lang]}</p>
          </div>
          {/* Translator — deliberately smaller */}
          <div data-testid="speaker-translator" className="w-full max-w-[190px] sm:max-w-none">
            <div className="relative">
              <img
                data-testid="speaker-photo-translator"
                src="/assets/speaker-translator.jpg"
                alt="Pr. John Stephen — Translator"
                className="aspect-[4/5] w-full rounded-xl border border-white/15 object-cover object-top"
              />
            </div>
            <h3 data-testid="speaker-translator-name" className="mt-6 text-center font-display text-sm font-bold uppercase tracking-wide text-white sm:text-lg">
              Pr. John Stephen
            </h3>
            <p className={`mt-1 text-center text-[11px] text-[#FFE500]/70 sm:text-xs ${lang === "kn" ? "font-kn" : ""}`}>{T.speakers.translatorBadge[lang]}</p>
          </div>
        </div>
      </div>
    </section>
  );
};
